import * as React from "react"
export const ProLockOpenIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="#E9E6FC"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="url(#paint0_radial_1114_4989)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="url(#paint1_radial_1114_4989)"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="url(#paint2_radial_1114_4989)"
      strokeOpacity="0.8"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="url(#paint3_radial_1114_4989)"
      strokeOpacity="0.7"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 11V7C8 4.79086 9.79086 3 12 3C14.2091 3 16 4.79086 16 7M12 15V17M6 21H18C19.1046 21 20 20.1046 20 19V13C20 11.8954 19.1046 11 18 11H6C4.89543 11 4 11.8954 4 13V19C4 20.1046 4.89543 21 6 21Z"
      stroke="black"
      strokeOpacity="0.25"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <defs>
      <radialGradient
        id="paint0_radial_1114_4989"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.0204 21) rotate(-127.956) scale(22.8286 41.2052)">
        <stop stopColor="#E9E6FC" stopOpacity="0" />
        <stop offset="1" stopColor="#C1BFF6" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_1114_4989"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(18.8571 1.71429) rotate(126.955) scale(24.7132 38.6528)">
        <stop stopColor="#A178FE" />
        <stop offset="1" stopColor="#BEA1FE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_1114_4989"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.5102 3) rotate(118.762) scale(22.7333 30.6562)">
        <stop stopColor="#E9E7FD" stopOpacity="0" />
        <stop offset="1" stopColor="#E9E7FD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_1114_4989"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(4 3) rotate(46.9926) scale(24.1753 58.0121)">
        <stop stopColor="#E9E6FC" stopOpacity="0" />
        <stop offset="0.501193" stopColor="#EDBFC5" stopOpacity="0.501193" />
        <stop offset="1" stopColor="#F1988F" />
      </radialGradient>
    </defs>
  </svg>
)
